//
// Copyright (c) 2011 - 2011-2017 by Curalate, Inc.
//

import _ from 'js/underscore-mixins';

const curalate = angular.module('curalate');

curalate.service('AssistedProductTaggingService', [
  '$http',
  'rx',
  'PromiseService',
  function ($http, rx, PromiseService) {
    const IPT_GATEWAY_URL = CURALATE_ENV.IPT_GATEWAY_URL;
    const IPT_BASE_ENDPOINT_V2 = '/api/v2/ipt';
    const cachedRelevancyData = {};
    const cachedRelevancyPromises = {};
    const productRelevancyDataStream = new rx.BehaviorSubject();
    const productRelevancyErrorStream = new rx.Subject();

    const convertX2Y2ToWidthHeight = function (coordinates) {
      return {
        x: coordinates.x1,
        y: coordinates.y1,
        width: coordinates.x2 - coordinates.x1,
        height: coordinates.y2 - coordinates.y1,
      };
    };

    this.getProductRelevancyDataSubject = function (itemId) {
      if (!cachedRelevancyData[itemId] && !cachedRelevancyPromises[itemId]) {
        cachedRelevancyPromises[itemId] = PromiseService.processHttpResponse(
          $http.get(
            `${IPT_GATEWAY_URL}${IPT_BASE_ENDPOINT_V2}/search/${itemId}`,
          ),
        )
          .then((result) => {
            _(result.boundingBoxes).each((boundingBox) => {
              boundingBox.coordinates = convertX2Y2ToWidthHeight(
                boundingBox.coordinates,
              );
            });

            cachedRelevancyData[itemId] = result;
            productRelevancyDataStream.next({
              itemId,
              relevancyData: cachedRelevancyData[itemId],
            });
          })
          .catch((error) => {
            delete cachedRelevancyPromises[itemId];
            productRelevancyErrorStream.next({ itemId, error });
          });
      }

      return productRelevancyDataStream.filter(
        (data) => data?.itemId === itemId,
      );
    };

    this.getProductRelevancyErrorSubject = function (itemId) {
      return productRelevancyErrorStream.filter(
        (data) => data?.itemId === itemId,
      );
    };

    this.getCachedBoundingBox = function (itemId, boxId) {
      const productRelevancyBoxes =
        cachedRelevancyData &&
        cachedRelevancyData[itemId] &&
        cachedRelevancyData[itemId].boundingBoxes;
      return _(productRelevancyBoxes).findWhere({ boxId });
    };

    this.getBoundingBoxByProductStyleId = function (itemId, productStyleId) {
      const productRelevancyBoxes =
        cachedRelevancyData &&
        cachedRelevancyData[itemId] &&
        cachedRelevancyData[itemId].boundingBoxes;
      return _(productRelevancyBoxes).find(
        (product) =>
          _(product).safeGet('selectedProduct.productStyleId') ===
          productStyleId,
      );
    };
  },
]);
